'use client'
import { Button } from '@fsg/gui-bits'


export default function Error({ error, reset }: { error?: Error; reset: () => void }) {
  console.error(error)

  return (
    <div className="grid h-full w-full items-center">
      <div>
        <h2>Something went wrong!</h2>
        <p>{error?.message}</p>
        <Button
          buttonType="secondary"
          onClick={
            // Attempt to recover by trying to re-render the segment
            () => reset()
            
          }
        >
          Try again
        </Button>
      </div>
    </div>
  )
}
